"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldDisableShareOptions = exports.getSharedUserFullName = exports.getSharingInviteDisplay = exports.checkIfWebfirstDataset = exports.checkIfInviteExpired = exports.formatLastSyncedDate = exports.getOwnerName = void 0;
const luxon_1 = require("luxon");
const datasetSharesTypes_1 = require("companion-app-components/flux/dataset-shares/datasetSharesTypes");
const constants_1 = require("utils/constants");
const getOwnerName = (grantorFirstName, grantorLastName) => {
    if (!grantorFirstName && !grantorLastName) {
        return constants_1.APP_STRING_NOT_APPLICABLE;
    }
    const firstName = grantorFirstName || '';
    const lastName = grantorLastName || '';
    return `${firstName} ${lastName}`;
};
exports.getOwnerName = getOwnerName;
const formatLastSyncedDate = (date) => {
    const originalDateTime = luxon_1.DateTime.fromISO(date);
    return originalDateTime.toFormat('MM/dd/yy, HH:mm');
};
exports.formatLastSyncedDate = formatLastSyncedDate;
const checkIfInviteExpired = (date) => {
    if (!date) {
        return false;
    }
    const dtNow = luxon_1.DateTime.local();
    const dtLastSent = luxon_1.DateTime.fromISO(date);
    const diff = luxon_1.Interval.fromDateTimes(dtLastSent, dtNow);
    const diffHours = diff.length('hours');
    if (diffHours > 24) {
        return true;
    }
    return false;
};
exports.checkIfInviteExpired = checkIfInviteExpired;
const checkIfWebfirstDataset = (platform) => platform ? ['QWIN_MWF', 'QMAC_MWF'].includes(platform) : false;
exports.checkIfWebfirstDataset = checkIfWebfirstDataset;
const getSharingInviteDisplay = (sharing) => {
    const hasExpiredInvite = (0, exports.checkIfInviteExpired)(sharing === null || sharing === void 0 ? void 0 : sharing.lastInviteSent);
    if ((sharing === null || sharing === void 0 ? void 0 : sharing.state) === datasetSharesTypes_1.DATASET_SHARING_STATES.INVITED && hasExpiredInvite) {
        return {
            isInvited: true,
            invitedLabel: 'Invitation Expired - ',
            color: 'number.negative',
        };
    }
    if ((sharing === null || sharing === void 0 ? void 0 : sharing.state) === datasetSharesTypes_1.DATASET_SHARING_STATES.INVITED) {
        return {
            isInvited: true,
            invitedLabel: 'Invited - ',
            color: 'inherit',
        };
    }
    if ((sharing === null || sharing === void 0 ? void 0 : sharing.state) === datasetSharesTypes_1.DATASET_SHARING_STATES.ABANDONED) {
        return {
            isInvited: true,
            invitedLabel: 'No longer shared - ',
            color: 'inherit',
        };
    }
    return {
        isInvited: false,
        invitedLabel: '',
        color: 'inherit',
    };
};
exports.getSharingInviteDisplay = getSharingInviteDisplay;
const getSharedUserFullName = (granteeFirstName, granteeLastName) => `${granteeFirstName || ''} ${granteeLastName || ''}`.trim();
exports.getSharedUserFullName = getSharedUserFullName;
const shouldDisableShareOptions = (sharingCount, maximumSharesPerDataset, isCFODataset, isCurrentDataset) => (sharingCount >= maximumSharesPerDataset
    || (isCFODataset && !isCurrentDataset));
exports.shouldDisableShareOptions = shouldDisableShareOptions;
